import './winmock10/style';
import FormStructure from './winmock10/form_structure';

export default FormStructure;